import type { ButtonHTMLAttributes, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { Button } from '@ui/buttons/Button.tsx';

const Wrapper = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
  border: none;
  border-radius: unset;
  &:focus-visible {
    outline-offset: 4px;
    border-radius: ${({ theme }) => theme.standardRadius};
  }
`;

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;
};

const IconButton = ({ children, onClick, ...props }: IconButtonProps) => {
  return (
    <Wrapper onClick={onClick} {...props}>
      {children}
    </Wrapper>
  );
};

export { IconButton };
